import { ReactElement, useEffect, useState } from "react";
import { IChartWrapperProps } from "../../types";
import TreeMapChart from "../../../../components/charts/treeMapChart";
import { IPoint, ITreeMapChartConfig, ITreeMapNode } from "../../../../components/charts/types";
import { getGenericChartConfig } from "./utils";

const TreeMapChartWrapper = ({ cell, data, parentSize, palette, updatePalette, node, schemas }: IChartWrapperProps): ReactElement => {
  const [ chartConfig, setChartConfig ] = useState<ITreeMapChartConfig | null>(null);

  useEffect(() => {
    if (data) {
      const [ series ] = getGenericChartConfig(data, cell, node, palette, updatePalette, schemas);

      const root: ITreeMapNode = {
        name: "root",
        value: 0,
        children: series.map(s => ({
          name: s.name,
          value: 0,
          color: s.color,
          children: (s.value as IPoint[]).map(p => ({
            name: p.x,
            value: p.y,
            color: s.color,
          } as ITreeMapNode))
        }))
      };

      setChartConfig( {
        height: parentSize.height - 10,
        width: parentSize.width,
        root,
        series,
        showLegend: true,
        showValue: true
      });
    }
  }, [ cell, data, parentSize, palette, updatePalette, node, schemas ]);

  return (
    <div className="display-flex-row" style={{ ...parentSize }}>
      {chartConfig && <TreeMapChart chartConfig={chartConfig}/>}
    </div>
  );
};

export default TreeMapChartWrapper;
